var vm = new Vue({
    el: "#YI",
    data: {
        menuActive: false,
        scrollTop: 0,
        data: {
            currPage: 1,
            list: [],
            pageSize: 1,
            totalCount: 0,
            totalPage: 1
        }
    },
    mounted: function() {
        var that = this;
        document.addEventListener("scroll", function() {
            //that.scrollTop = window.scrollY;
        });
        window.addEventListener("touchmove", function(event) {
            //that.scrollTop = window.scrollY;
        });
        this.getNews();
    },
    methods: {
        goto: function(id) {
            var offsetTop = document.querySelector("#" + id).offsetTop;
            window.scrollTo({
                top: offsetTop - 50,
                behavior: "smooth"
            });
        },
        getNews: function() {
            var that = this;
            Y.Axios.get(G.Api + "/home/news/list").then(function(reply) {
                if (reply.msg === "success") {
                    that.data = reply.data;
                }
            });
        },
        toggleMenu: function() {
            this.menuActive = !this.menuActive;
        }
    }
});
